import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAuth from './useAuth'
import { supabase } from '../lib/supabase'
import LoadingSpinner from './LoadingSpinner'

function ProtectedRoute({ children }) {
  const { isAuthed, loading, user } = useAuth()
  const location = useLocation()
  // null = still checking; true/false once the profile read resolves.
  const [phoneVerified, setPhoneVerified] = useState(null)

  useEffect(() => {
    if (!user) return
    let cancelled = false
    supabase
      .from('profiles')
      .select('phone_verified')
      .eq('id', user.id)
      .maybeSingle()
      .then(({ data, error }) => {
        if (cancelled) return
        // Fail open on a read error: the DB trigger and the claim/release Edge
        // Functions are the authoritative gate — this redirect is only UX, so a
        // transient profile-read failure must not lock out a verified merchant.
        setPhoneVerified(error ? true : Boolean(data?.phone_verified))
      })
    return () => {
      cancelled = true
    }
  }, [user])

  if (loading) {
    return <LoadingSpinner message="Loading…" />
  }

  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (phoneVerified === null) {
    return <LoadingSpinner message="Loading…" />
  }

  // Unverified merchants finish onboarding (business profile + phone OTP) at
  // /get-started, which routes them back to /dashboard once verified.
  if (!phoneVerified) {
    return <Navigate to="/get-started" replace />
  }

  return children
}

export default ProtectedRoute
